import { render } from "./EmployeeDataImport.vue?vue&type=template&id=83d312d2&scoped=true"
import script from "./EmployeeDataImport.vue?vue&type=script&lang=js"
export * from "./EmployeeDataImport.vue?vue&type=script&lang=js"

import "./EmployeeDataImport.vue?vue&type=style&index=0&id=83d312d2&lang=scss&scoped=true"

import exportComponent from "/Users/nisalatp/Projects/Herd/OrangeHRM/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83d312d2"]])

export default __exports__